<template>
	<v-form @submit="storeData">
		<v-dialog
			v-model="dialog"
			persistent
			max-width="600px"
		>
			<template
				#activator=" { props }"
			>
				<v-btn
					variant="outlined"
					color="primary"
					size="small"
					class="pull-right"
					v-bind="props"
				>
					<translate class="text-break">
						Edit Address
					</translate>
				</v-btn>
			</template>
			<v-card>
				<v-card-title>
					<span class="text-h5"><translate>Edit temporary address</translate></span>
				</v-card-title>
				<v-card-text>
					<v-container>
						<v-row>
							<v-col
								cols="12"
								sm="6"
								md="4"
							>
								<v-text-field
									id="street"
									v-model="street"
									variant="outlined"
									:label="$gettext('Street')"
									required
									:rules="[() => street.length > 0 || 'Required field']"
								/>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								md="4"
							>
								<v-text-field
									id="Housenumber"
									v-model="housenumber"
									variant="outlined"
									:label="$gettext('House Number')"
									required
									:rules="[() => housenumber.length > 0 || 'Required field']"
								/>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								md="4"
							>
								<v-text-field
									id="Suffix"
									v-model="suffix"
									variant="outlined"
									:label="$gettext('Suffix')"
								/>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								md="8"
							>
								<v-text-field
									id="City"
									v-model="city"
									variant="outlined"
									:label="$gettext('City')"
									required
									:rules="[() => city.length > 0 || 'Required field']"
								/>
							</v-col>
							<v-col
								cols="12"
								sm="6"
								md="4"
							>
								<v-text-field
									id="postalcode"
									v-model="postalcode"
									variant="outlined"
									:label="$gettext('Postal Code')"
									required
									:rules="[() => postalcode.length > 0 || 'Required field']"
								/>
							</v-col>
							<v-col
								cols="12"
								sm="6"
							>
								<v-select
									id="Country"
									v-model="country"
									variant="outlined"
									:items="['Netherlands']"
									:label="$gettext('Country')"
									:rules="[() => country.length > 0 || 'Required field']"
								/>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions>
					<v-spacer />
					<v-btn
						color="red-darken-1"
						variant="text"
						type="cancel"
						@click="oncancel"
					>
						<translate>Cancel</translate>
					</v-btn>
					<v-btn
						color="green-darken-1"
						variant="text"
						type="submit"
						@click="storeData"
					>
						<translate>Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-form>
</template>

<script>
import axios from 'axios';

export default {
	name: 'AddressModal',
	props: {
		claimid: {
			type: String,
			default: '',
		}
	},

	data () {
		return {
			activationEvent: '',
			attrs: '',
			dialog: false,
			street: '',
			housenumber: '',
			suffix: '',
			postalcode: '',
			city: '',
			country: '',
		};
	},

	methods: {
		/**
		 * Resets address data
		 *
		 * @returns {void}
		 */
		oncancel () {
			this.dialog = false;
			this.street = '';
			this.housenumber = '';
			this.suffix = '';
			this.postalcode = '';
			this.city = '';
			this.country = '';
			this.claimID = '';
		},

		/**
		 * @param {Array} fieldCheckArray
		 * @returns	{boolean}
		 */
		checkFields (fieldCheckArray) {
			return !fieldCheckArray.includes('');
		},

		/**
		 * @param {object} e
		 * @returns {void}
		 */
		storeData (e) {
			e.preventDefault();
			const formData = new FormData();
			const formArray = [
				this.street.trim(),
				this.housenumber.trim(),
				this.postalcode.trim(),
				this.city.trim(),
				this.country.trim(),
			];

			if (formArray.includes('')) {
				// eslint-disable-next-line no-alert
				alert('One of the required fields is not filled in.');
				return;
			}

			formData.append('street', this.street.trim());
			formData.append('housenumber', this.housenumber.trim());
			formData.append('suffix', this.suffix.trim());
			formData.append('postalcode', this.postalcode.trim());
			formData.append('city', this.city.trim());
			formData.append('country', this.country.trim());
			formData.append('claim_id', this.claimid);

			axios({
				url: '/bo/claims/AlternativeAddress',
				method: 'POST',
				dataType: 'application/json',
				data: formData,
				config: {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
				},
			}) .then(() => {
				this.street = '';
				this.housenumber = '';
				this.suffix = '';
				this.postalcode = '';
				this.city = '';
				this.country = '';
				this.dialog = false;
				window.location.reload();
			}).catch(function (error) {
				// eslint-disable-next-line no-alert
				alert('Something went wrong, please try again. Errorcode: ' + error.response.status);
			});
		}
	}
};
</script>
